import React, { useEffect, useState } from 'react'
import { Descriptions,  Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import { useBnsXuQiuUpdateQuery } from '../../store/BnsKeJiApi';

function RequireDesc(props) {
    const [info,setInfo] = useState({
        ebn_team_num:'',
    })
    const {data,isSuccess} = useBnsXuQiuUpdateQuery({bxq_id:props.bxq_id},{skip:!props.bxq_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bxq_cname:data.Result.bxq_cname,                   
                    bxq_content:data.Result.bxq_content,                   
                    bxq_dept_name:data.Result.bxq_dept_name,                   
                    bxq_name:data.Result.bxq_name,                   
                    bxq_ctime:data.Result.bxq_ctime,                      
                    bxq_state:data.Result.bxq_state,                      
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'content',
            label:'说明',
            children:<div dangerouslySetInnerHTML={{__html:info.bxq_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3,
        },
        {
            key:'status',
            label:'状态',
            children:info.bxq_state==='1'?<>已实现</>:<span style={{color:'red'}}>待实现</span>,
            labelStyle:{width:'100px'},
            contentStyle:{fontSize:"18px"}
        },
       
        {
            key:'11',
            label:'部门',
            children:<>{info.bxq_dept_name}</>,
            labelStyle:{width:'100px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'13',
            label:'新增时间',
            children:<>{info.bxq_cname + info.bxq_ctime}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },       

    ]
    return (
        <>
            {info.bxq_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                    <DocTitle
                                        name={info.bxq_name}
                                        num={props.bxq_id}                        
                                    />
                                    <Descriptions
                                        items={items} 
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default RequireDesc